import type { Location, NavigateFunction } from 'react-router-dom';

export const getQueryValue = (key: string): string => {
    const search = new URLSearchParams(window.location.search);
    const value = search.get(key);

    return value ? decodeURIComponent(value) : null;
};

export const setQueryValue = (key: string, value: string, location: Location, navigate: NavigateFunction): void => {
    const search = new URLSearchParams(location.search);
    const encodedValue = value ? encodeURIComponent(value) : '';
    if (search.get(key)) {
        search.set(key, encodedValue);
    } else {
        search.append(key, encodedValue);
    }

    const s = search.toString();
    const newSearch = s[0] === '?' ? s : `?${s}`;
    navigate(`${location.pathname}${newSearch}${location.hash}`, { replace: true });
};
